<template>
        
        <div class="" style="flex-wrap:wrap;width:100%;">
            <p v-if="hospedesprincipais.length">Reservas</p>
            <h2 style="text-align:center;padding-top:3vh;margin-bottom:50px;font-size:20px!important;" >{{ hospedesprincipais.length ? "Clique no Hospede Principal da Sua Reserva" : "Nenhuma reserva encontrada para esse hospede."}}</h2>
            <div style="display: flex; justify-content: center;align-items: center;">
                <v-btn style="width:50%;margin-bottom:0px; margin:auto" @click="()=>  this.$emit('voltar',)" color="primary">Voltar</v-btn>
            </div>
                    <div class="resumoInicialHospedes"  v-for="hospede in hospedesprincipais" :key="hospede.id"
                        style="margin-bottom:30px;margin-top:20px;" @click="direcionarParaReservas(hospede.reserva)">
                        <div style="margin-bottom:10px;display:flex;">
                            <div style="margin-right:10px;font-weight:bold!important;">Numero da Reserva:</div>
                            <div>{{hospede.reserva}}</div>
                        </div>
                        <div style="margin-bottom:10px;display:flex;">
                            <div style="margin-right:10px;font-weight:normal!important;">Nome:</div>
                            <div>{{hospede.nome+' '+hospede.sobrenome}}</div>
                        </div>
                        <div style="display:flex;justify-content:space-between;">
                            <div style="margin-bottom:10px;">
                                <div><b>Chegada</b></div>
                                <div>{{dados.datacheckinprevisto | formatarData}}</div>
                            </div>
                            <div style="margin-bottom:10px;">
                                <div><b>Saída</b></div>
                                <div>{{dados.datacheckoutprevisto | formatarData}}</div>
                            </div>
                        </div>
                        <div style="margin-bottom: 10px!important;" v-if="hospede.acompanhantes && hospede.acompanhantes.length > 0">
                            <div style="margin-right:20px;font-weight:normal!important;"><b>Outros hospedes: </b></div>
                            <div style="margin-left: 5px;" v-for="(acompanhante, index) in hospede.acompanhantes" :key="index"> - {{acompanhante.nome+' '+acompanhante.sobrenome}}</div>
                        </div>
                        
                    </div>

            <!-- Modal para solicitar número da reserva quando há múltiplos registros -->
            <v-dialog v-model="dialogNumeroReserva" width="500" persistent>
                <v-card>
                    <v-toolbar color="orange" dark>
                        <v-toolbar-title>Múltiplas Reservas com Nomes Similares</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="pt-4">
                        <div class="mb-3">
                            <p>Foram encontradas <strong>{{ registrosMultiplos.length }}</strong> reservas com nomes similares.</p>
                            <p>Para uma busca mais precisa, informe o número da reserva desejada:</p>
                            <p>O numero é encontrado no seu Voucher:</p>
                        </div>
                        <v-text-field
                            v-model="numeroReservaSolicitado"
                            label="Número da Reserva"
                            type="text"
                            outlined
                            dense
                            @keyup.enter="confirmarNumeroReserva"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey" text @click="cancelarSolicitacaoReserva">
                            Ver Todos
                        </v-btn>
                        <v-btn color="primary" @click="confirmarNumeroReserva" :disabled="!numeroReservaSolicitado">
                            Buscar Reserva
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

</template>

<script>

// import moment from 'moment'
export default { 
    props:["dados"],
    data: () =>{
        return {
            // // os dados que salvarei na base do ficha
            hospedesprincipais:[],
            hospedeprincipal:null,
            dialogNumeroReserva: false,
            numeroReservaSolicitado: '',
            registrosMultiplos: []

        }
    },
    methods:{
        direcionarParaReservas(numeroreserva){
            console.log(numeroreserva)

            var dadossalvar     = this.dados
            dadossalvar.numeroreserva   = numeroreserva

           
            this.$emit('atualizarDados',dadossalvar,'Reservas')
        },
        listarHospedesPrincipais(){
       
            var nome = null
            var sobrenome = null
         

            if(this.dados.nome){
             
                const nomeCompleto = this.dados.nome.trim();
                      const partes = nomeCompleto.split(/\s+/);
                     nome = '%'+partes[0].trim()+'%';
                    //  sobrenome = partes.slice(1).join(' ');
                    sobrenome = '%'
                     for(let i= 1, len = partes.length; i < len; i++){
                        if(partes[i] && partes[i].length > 2){
                            sobrenome += partes[i].trim()+'%';
                        }
                     }
                     

       
            }

            this.$http.post("reserva/selecionarReservasCheckinExpress",{
                data_checkin:this.dados.datacheckinprevisto,
                data_checkout:this.dados.datacheckoutprevisto,
                nome:nome,
                sobrenome:sobrenome
                // hotel:localStorage.getItem('hotel'),
                })
            .then(resp =>{
                console.log(resp.data)
                    // alert(JSON.stringify(resp.data))
                    // this.hospedesprincipais = resp.data.filter(p => {
                    //     return p.nome != undefined;
                    // }).sort((a, b) => (a.nome > b.nome) ? 1 : -1);
                    
                    // Verificar se há múltiplos registros com nomes similares e números de reserva diferentes
                    if (this.verificarMultiplosRegistrosMesmoNome(resp.data)) {
                        this.dialogNumeroReserva = true
                        return
                    }
                    
                    this.hospedesprincipais = resp.data;
                    

            }).catch(error =>{
                alert(error)
            })
        },
        
        // Método para calcular similaridade entre duas strings (algoritmo de Levenshtein simplificado)
        calcularSimilaridade(str1, str2) {
            // Normalizar strings (remover acentos, converter para minúsculas, remover espaços extras)
            const normalizar = (str) => {
                return str.toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
                    .replace(/\s+/g, ' ') // Remove espaços extras
                    .trim()
            }
            
            const s1 = normalizar(str1)
            const s2 = normalizar(str2)
            
            if (s1 === s2) return 1.0 // Idênticas
            
            // Calcular distância de Levenshtein
            const matriz = []
            const len1 = s1.length
            const len2 = s2.length
            
            // Inicializar matriz
            for (let i = 0; i <= len1; i++) {
                matriz[i] = [i]
            }
            for (let j = 0; j <= len2; j++) {
                matriz[0][j] = j
            }
            
            // Preencher matriz
            for (let i = 1; i <= len1; i++) {
                for (let j = 1; j <= len2; j++) {
                    if (s1.charAt(i - 1) === s2.charAt(j - 1)) {
                        matriz[i][j] = matriz[i - 1][j - 1]
                    } else {
                        matriz[i][j] = Math.min(
                            matriz[i - 1][j - 1] + 1, // substituição
                            matriz[i][j - 1] + 1,     // inserção
                            matriz[i - 1][j] + 1      // deleção
                        )
                    }
                }
            }
            
            const distancia = matriz[len1][len2]
            const maxLen = Math.max(len1, len2)
            
            // Retorna similaridade (0 a 1, onde 1 é idêntico)
            return maxLen === 0 ? 1 : (maxLen - distancia) / maxLen
        },
        
        // Método para verificar se dois nomes são similares
        nomesSaoSimilares(nome1, sobrenome1, nome2, sobrenome2) {
            const nomeCompleto1 = `${nome1} ${sobrenome1}`
            const nomeCompleto2 = `${nome2} ${sobrenome2}`
            
            // Calcular similaridade do nome completo
            const similaridadeCompleta = this.calcularSimilaridade(nomeCompleto1, nomeCompleto2)
            
            // Também verificar similaridade individual dos nomes e sobrenomes
            const similaridadeNome = this.calcularSimilaridade(nome1, nome2)
            const similaridadeSobrenome = this.calcularSimilaridade(sobrenome1, sobrenome2)
            
            // Considerar similar se:
            // 1. Nome completo tem similaridade >= 80%
            // 2. OU (Nome >= 85% E Sobrenome >= 85%)
            // 3. OU Nome completo >= 75% E pelo menos um dos nomes individuais >= 90%
            return (
                similaridadeCompleta >= 0.80 ||
                (similaridadeNome >= 0.85 && similaridadeSobrenome >= 0.85) ||
                (similaridadeCompleta >= 0.75 && (similaridadeNome >= 0.90 || similaridadeSobrenome >= 0.90))
            )
        },
        
        // Método para verificar se há múltiplos registros com nomes similares mas números de reserva diferentes
        verificarMultiplosRegistrosMesmoNome(dados) {
            // Só verifica se há dados e não há filtro de reserva específica
            if (dados.length > 1) {
                
                // Agrupar registros por similaridade de nomes
                const gruposSimilares = []
                const processados = new Set()
                
                for (let i = 0; i < dados.length; i++) {
                    if (processados.has(i)) continue
                    
                    const grupo = [dados[i]]
                    processados.add(i)
                    
                    // Buscar registros similares
                    for (let j = i + 1; j < dados.length; j++) {
                        if (processados.has(j)) continue
                        
                        if (this.nomesSaoSimilares(
                            dados[i].nome, dados[i].sobrenome,
                            dados[j].nome, dados[j].sobrenome
                        )) {
                            grupo.push(dados[j])
                            processados.add(j)
                        }
                    }
                    
                    if (grupo.length > 1) {
                        gruposSimilares.push(grupo)
                    }
                }
                
                // Verificar se algum grupo tem múltiplas reservas com números diferentes
                for (const grupo of gruposSimilares) {
                    const numerosReserva = grupo.map(item => item.reserva)
                    const numerosUnicos = [...new Set(numerosReserva)]
                    
                    if (numerosUnicos.length > 1) {
                        // Armazenar todos os registros similares para exibição no popup
                        this.registrosMultiplos = grupo
                        return true
                    }
                }
            }
            return false
        },
        
        // Método para confirmar o número da reserva no popup
        confirmarNumeroReserva() {
            if (this.numeroReservaSolicitado) {
                this.dialogNumeroReserva = false
                const numeroSolicitado = this.numeroReservaSolicitado
                this.numeroReservaSolicitado = ''
                this.registrosMultiplos = []
                // Pesquisar novamente com o número da reserva
                this.listarHospedesPrincipaisComReserva(numeroSolicitado)
            }
        },
        
        // Método para cancelar a solicitação do número da reserva
        cancelarSolicitacaoReserva() {
            this.dialogNumeroReserva = false
            this.numeroReservaSolicitado = ''
            // Exibir todos os registros similares encontrados
            this.hospedesprincipais = this.registrosMultiplos
            this.registrosMultiplos = []
        },
        
        // Método para listar hóspedes principais com número de reserva específico
        listarHospedesPrincipaisComReserva(numeroreserva) {
            var nome = null
            var sobrenome = null
         
            if(this.dados.nome){
                const nomeCompleto = this.dados.nome.trim();
                const partes = nomeCompleto.split(/\s+/);
                nome = '%'+partes[0].trim()+'%';
                sobrenome = '%'
                for(let i= 1, len = partes.length; i < len; i++){
                    if(partes[i] && partes[i].length > 2){
                        sobrenome += partes[i].trim()+'%';
                    }
                }
            }

            this.$http.post("reserva/selecionarReservasCheckinExpress",{
                data_checkin:this.dados.datacheckinprevisto,
                data_checkout:this.dados.datacheckoutprevisto,
                nome:nome,
                sobrenome:sobrenome,
                numeroreserva:numeroreserva
                })
            .then(resp =>{
                console.log(resp.data)
                this.hospedesprincipais = resp.data;
            }).catch(error =>{
                alert(error)
            })
        },
        
        salvarDados(){
            
            // var dadossalvar     = this.dados
            // dadossalvar.canal   = this.canal.idempresareservante
           
            // this.$emit('atualizarDados',dadossalvar,'Reservas')
            

        },
        async avancar(){

            if( await this.validarFormulario() ){
                this.salvarDados()
            }  
            
        }
    },
    mounted(){
        this.listarHospedesPrincipais()
    }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>